import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EventHero = ({ event, onShare }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatTime = (timeString) => {
    const time = new Date(`2000-01-01T${timeString}`);
    return time?.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  return (
    <div className="relative h-96 md:h-[500px] overflow-hidden rounded-lg mb-8">
      <Image
        src={event?.heroImage}
        alt={event?.name}
        className="w-full h-full object-cover"
      />
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
      {/* Event Info Overlay */}
      <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-bold mb-4 leading-tight">
            {event?.name}
          </h1>
          
          <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8 mb-6">
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={20} />
              <span className="text-lg">{formatDate(event?.date)}</span>
            </div>
            
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={20} />
              <span className="text-lg">{formatTime(event?.time)}</span>
            </div>
            
            <div className="flex items-center gap-2">
              <Icon name="MapPin" size={20} />
              <span className="text-lg">{event?.venue?.name}</span>
            </div>
          </div>
          
          {/* Share Button */}
          <div className="flex items-center gap-4">
            <Button
              variant="outline"
              size="sm"
              iconName="Share2"
              onClick={onShare}
              className="bg-white/10 border-white/20 text-white hover:bg-white/20"
            >
              Share Event
            </Button>
            
            {event?.isFeatured && (
              <div className="flex items-center gap-2 px-3 py-1 bg-accent rounded-full">
                <Icon name="Star" size={16} />
                <span className="text-sm font-medium">Featured Event</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventHero;